import React, { useEffect } from "react";
import { Table, Image, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useAboutUsModel } from "../aboutUsModel";
import { IAboutUsDetail } from "../aboutUsService";
import { getBaseRequestUrl, getToken, getFileUrl } from "@/utils/constants";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useAboutUsModel();

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IAboutUsDetail> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '公司名称',
            width: 160,
            dataIndex: 'name',
            fixed: "left",
        }, {
            title: '公司地址',
            width: 160,
            dataIndex: 'address',
        }, {
            title: '公司logo',
            width: 100,
            dataIndex: 'logo',
            className: "p-0",
            render: (text, record) => record.logo ? <Image src={getFileUrl(record.logo)} style={{ width: "40px", height: "40px", marginRight: "10px" }} /> : ""
        }, {
            title: '公司简介',
            width: 180,
            dataIndex: 'profiles',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>,
        },
        {
            title: '创建人',
            width: 160,
            dataIndex: 'createUser',
            align: "center"
        },
        {
            title: '创建时间',
            width: 180,
            dataIndex: 'createTime',
        }
    ];


    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            rowKey={record => record.id ?? ""}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id);
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId] as string[])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id ?? ""),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id ?? ""),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id ?? ""]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}